import type { ReactElement } from "react";

interface ProductTileSaveIconProps {
  filled?: boolean;
  hovered?: boolean;
}

export const ProductTileSaveIcon = ({
  filled = false,
  hovered = false,
}: ProductTileSaveIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M12.0002 21.4286L2.53901 12.7767C-2.57127 7.66637 4.9493 -2.24221 12.0002 5.74808C19.051 -2.24221 26.5716 7.66636 21.4613 12.7766L12.0002 21.4286Z"
      fill="#333333"
      fillOpacity={filled ? 1 : hovered ? 0.7 : 0.5}
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
